export default {
    mySubscriptionsInitial(state, bool) {
        state.mySubscriptionsInitial = bool;
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/MySubscriptions/mutations.js